import { useState } from "react";
import { Collapse, Menu } from "react-daisyui";
import { NavLink } from "react-router-dom";
import { types } from "../graphql";

function LeftSidebar({
  zone,
  participants,
  closeSidebar,
}: {
  zone: types.Zone;
  participants: types.Participant[];
  closeSidebar: () => void;
}) {
  const [blocksOpen, setBlocksOpen] = useState(true);
  const [participantsOpen, setParticipantsOpen] = useState(true);

  return (
    <div className="bg-base-100 px-1">
      <Collapse
        checkbox
        icon="arrow"
        open={blocksOpen}
        onToggle={() => setBlocksOpen((blocksOpen) => !blocksOpen)}
        className="rounded-md"
      >
        <Collapse.Title className="bg-base-300">Blocks</Collapse.Title>
        <Collapse.Content className="bg-base-200">
          <Menu className="h-full w-80 text-base-content">
            {(zone?.blocks ?? []).map((block) => (
              <Menu.Item key={block.blockId}>
                <NavLink
                  end
                  to={`/zone/blocks/${block.blockId}`}
                  onClick={closeSidebar}
                  className={({ isActive }) =>
                    isActive ? "bg-base-200  font-semibold" : "font-normal"
                  }
                >
                  {({ isActive }) => (
                    <>
                      {block.blockType}
                      {isActive && (
                        <span
                          className="absolute inset-y-0 left-0 w-1 rounded-bl-md rounded-tl-md bg-primary "
                          aria-hidden="true"
                        ></span>
                      )}
                    </>
                  )}
                </NavLink>
              </Menu.Item>
            ))}
          </Menu>
        </Collapse.Content>
      </Collapse>
      <Collapse
        checkbox
        icon="arrow"
        open={participantsOpen}
        onToggle={() =>
          setParticipantsOpen((participantsOpen) => !participantsOpen)
        }
        className="mt-2 rounded-md"
      >
        <Collapse.Title className="bg-base-300">Participants</Collapse.Title>
        <Collapse.Content className="bg-base-200">
          <Menu className="h-full w-80 text-base-content">
            {participants.map((participant) => (
              <Menu.Item key={participant.participantId}>
                <NavLink
                  end
                  to={`/zone/participants/${participant.participantId}`}
                  onClick={closeSidebar}
                  className={({ isActive }) =>
                    isActive ? "bg-base-200  font-semibold " : "font-normal"
                  }
                >
                  {({ isActive }) => (
                    <>
                      {participant.active && (
                        <span className="text-accent">*</span>
                      )}
                      {participant.username}
                      {isActive && (
                        <span
                          className="absolute inset-y-0 left-0 w-1 rounded-bl-md rounded-tl-md bg-primary "
                          aria-hidden="true"
                        ></span>
                      )}
                    </>
                  )}
                </NavLink>
              </Menu.Item>
            ))}
          </Menu>
        </Collapse.Content>
      </Collapse>
    </div>
  );
}

export default LeftSidebar;
